/* eslint-disable no-loop-func */
import CdnImage from '../../../components/cdnImage/cdnImage.js'

const stringUtil = require('../../../utils/string/stringUtil.js');
const dateUtil = require('../../../utils/dateUtil/dateUtil.js');
const configurationManager = require('../../../utils/config/configurationManager.js');
const themeUtil = require('../../../utils/view/themeUtil.js');

export default function RotaViewTableRow(props)
{

    let rotaStaff = props.rotaStaff;
    let endDate = props.endDate;
    let fromDate = props.fromDate;

    var staffRowComponents = [];
    staffRowComponents.push(<td style={{ zIndex: 999, top: 'auto', left: 0, position: 'sticky', background: '#FFFFFF', textAlign: 'center', verticalAlign: 'middle' }}>{renderStaffNameCell(rotaStaff)}</td>);

    while (fromDate <= endDate)
    {
        if (props.rotaDates.includes(fromDate))
        {
            var staffDateCellComponents = [];
            getAllRotasForDate(fromDate, props.rotas).forEach(rota =>
            {
                if (rota.staffId != rotaStaff.staffId)
                    return;

                var localStart = dateUtil.convertToLocalStandard(rota.start);
                var localEnd = dateUtil.convertToLocalStandard(rota.end);

                var caption = `${dateUtil.formatDate(localStart, "hh:mm A")} - ${dateUtil.formatDate(localEnd, "hh:mm A")}`
                staffDateCellComponents.push(<div style={{ whiteSpace: "nowrap" }}>{caption}</div>)
            });

            if (staffDateCellComponents.length > 0)
                staffRowComponents.push(<td style={{ background: '#FFFFFF', textAlign: 'center', verticalAlign: 'middle' }}>{staffDateCellComponents}</td>);
            else
                staffRowComponents.push(<td style={{ background: '#F7E4E4', textAlign: 'center', verticalAlign: 'middle' }}>N/A</td>);
        }
        fromDate = dateUtil.addDays(fromDate, 1);
    }

    return <tr key={rotaStaff.staffId}>{staffRowComponents}</tr>;
}

function renderStaffNameCell(rotaStaff)
{
    var imageComponent = null;
    if (!stringUtil.isStringNullOrEmpty(rotaStaff.pictUrl))
        imageComponent = <div style={{ textAlign: 'center' }}> <CdnImage cloudName={configurationManager.getConfig().cdnUsersCloudName} publicId={rotaStaff.pictUrl} width="50" height="50" radius="0" /></div>;
    else
        imageComponent = <div style={{ textAlign: 'center' }}> <CdnImage cloudName={configurationManager.getConfig().cdnAppCloudName} publicId={themeUtil.getPublicId('staff.png')} width="50" height="50" radius="0" /></div>;

    return <div>
        <div>
            {imageComponent}
        </div>
        <div style={{ textAlign: 'center', marginTop: '8px' }}>
            {rotaStaff.name}
        </div>
    </div>
}

function getAllRotasForDate(date, rotas)
{
    var dateRotas = [];
    rotas.forEach(rota =>
    {
        if (!dateUtil.isDateComponentSame(rota.start, date))
            return;

        dateRotas.push(rota);
    });
    return dateRotas;
}